'use client';

import React, { useState, useEffect } from 'react';
import Footer from '@/components/common/Footer';
import QuickAccessTiles from './QuickAccessTiles';
import TrustSignals from './TrustSignals';
import GlobalPresenceMap from './GlobalPresenceMap';
import ProductCategories from './ProductCategories';
import RegulatoryExpertise from './RegulatoryExpertise';
import SuccessMetrics from './SuccessMetrics';
import LatestUpdates from './LatestUpdates';
import CTASection from './CTASection';
import HeroSection from './HeroSection';
import ProductSlideshow from './ProductSlideshow';


export default function HomepageInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <main>
          <div className="container mx-auto px-4 py-16">
            <div className="animate-pulse space-y-8">
              <div className="h-96 bg-muted rounded-lg"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="h-48 bg-muted rounded-lg"></div>
                <div className="h-48 bg-muted rounded-lg"></div>
                <div className="h-48 bg-muted rounded-lg"></div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <main className="w-full">
        <HeroSection />
        <ProductSlideshow />
        <QuickAccessTiles />
        <TrustSignals />
        <SuccessMetrics />
        <ProductCategories />
        <RegulatoryExpertise />
        <GlobalPresenceMap />
        <LatestUpdates />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}